import React, { useState, useEffect } from "react"
import { Form, Button, Table } from "antd";
import { FormItemTypeEnum } from "../../../../components2/YhFormBox/Types"
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import { useHistoryModel } from "../dataHistoryModel"
import useMdmModel from "../../../../model/mdmModel"
import { useNavModel } from "../../../../model/navModel";
import { DetailType } from "../../../../types/FmsEnums";
import { IBranchInsert, IBranchUpadata } from "../../dataBranch/dataBranchTypes";
import { setTitle } from "../../../../utils/utils"
import moment from "moment"
import ReactJson from 'react-json-view'
const HistoryDetail = () => {
    const [form] = Form.useForm();
    const { mdmCatalog, mdmBranch } = useMdmModel();
    const { selectedNavId, addNav, closeNav, getSelectedNavState } = useNavModel()
    const {selectedRow} = useHistoryModel()
    const [modes, setModes] = useState<any>(getSelectedNavState("state"))
    const { id, pageParams } = modes
    const { mode, id: ids } = pageParams
    useEffect(() => {
        form.setFieldsValue(selectedRow)
    }, [])
    const items = [
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "执行编码",
            labelCol: { span: 6 },
            fieldName: "changeCode",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "数据目录",
            labelCol: { span: 6 },
            fieldName: "catalog",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "分支编码",
            labelCol: { span: 6 },
            fieldName: "branch",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "数据编码",
            labelCol: { span: 6 },
            fieldName: "dataCode",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "数据版本",
            labelCol: { span: 6 },
            fieldName: "dataVer",
        },     
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "创建人",
            labelCol: { span: 6 },
            fieldName: "updateUser",
        },
        {
            type: FormItemTypeEnum.Datepicker,
            span: 8,
            fieldLabel: "生成时间",
            labelCol: { span: 6 },
            fieldName: "createTime",
            showTime:true
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "备注",
            labelCol: { span: 6 },
            fieldName: "note",
        },
        {
            type: FormItemTypeEnum.JsonView,
            span: 16,
            fieldLabel: "数据内容",
            labelCol: { span: 3 },
            fieldName: "note",
            json:selectedRow.data??null
        },
    ]
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}数据分支</div>
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { addNav("1-4"); closeNav(id) }}
        >取消</Button>
    </>
    return <Form
        form={form}
    >
        <YhFormItemsBox disabled={mode == DetailType.look}  items={items} title={title} action={action} IclassName="p-20" />
    </Form>
}
export default HistoryDetail